export enum PanelType {
  Layer = 1,
  None = 0, // only used for mobile
  Object = 2,
  PathEdit = 3,
}

export default {
  PanelType,
};
